import { get } from 'lodash/fp';

function getRequirementFulfilled(base, type, findKey, findValue) {
  if (base) {
    const matchAnything = findValue === '*';
    if (type === 'array') {
      const foundItem = base.find((item) => {
        if (matchAnything) {
          return !!get(findKey, item);
        }
        return get(findKey, item) === findValue;
      });
      return { foundItem, meetsRequirement: !!foundItem };
    }
    if (type === 'string') {
      if (matchAnything) {
        return {
          meetsRequirement: !!get(findKey, base),
          foundItem: get(findKey, base),
        };
      }
      return {
        foundItem: get(findKey, base),
        meetsRequirement: get(findKey, base) === findValue,
      };
    }
  }

  return { meetsRequirement: true, foundItem: undefined };
}

export default function useVisibilityRequirement(
  base: string,
  item: any,
  propertyType: 'string' | 'array',
  findKey: string,
  findValue: string
) {
  const finderBase = get(base, item);
  const { meetsRequirement, foundItem } = getRequirementFulfilled(
    finderBase,
    propertyType,
    findKey,
    findValue
  );

  return {
    meetsRequirement,
    foundItem,
    base: finderBase,
  };
}

// Non-hook implementation
export function getVisibilityFromRequirement(
  base: string,
  item: any,
  propertyType: 'string' | 'array',
  findKey: string,
  findValue: string
) {
  const finderBase = get(base, item);
  const { meetsRequirement, foundItem } = getRequirementFulfilled(
    finderBase,
    propertyType,
    findKey,
    findValue
  );

  return {
    meetsRequirement,
    foundItem,
    base: finderBase,
  };
}
